export default __webpack_public_path__ + "static/media/02_Awaken-DAO.13cc17f4.png";